import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle.ts";

interface DownloadFileOptions {
	openInNewTab?: boolean;
}

export function downloadFile(fileHandle: FrontendDownloadFileHandle): void;
export function downloadFile(fileHandle: FrontendDownloadFileHandle, options: DownloadFileOptions): void;
export function downloadFile(fileHandle: FrontendDownloadFileHandle, options?: DownloadFileOptions) {
	downloadFileUrl(fileHandle.fileName, fileHandle.fileUrl, options);
}

export const createAndDownloadFile = (filename: string, content: string, encoding: string = "utf-8") => {
	downloadFileUrl(filename, `data:text/plain;charset=${encoding},` + encodeURIComponent(content));
};

export const downloadFileUrl = (filename: string, href: string, options?: DownloadFileOptions) => {
	const link = document.createElement("a");
	link.setAttribute("download", filename);
	link.href = href;
	link.style.display = "none";
	if (options?.openInNewTab !== false) link.target = "_blank";
	document.body.appendChild(link);
	link.click();
	link.remove();
};
